export default __webpack_public_path__ + "static/media/turkgo-screenshot-04.3653ffb4.png";